import {departureStart, getTrafficIconUrl, returnArrival} from "@COMPONENTS/common/eventUtil";
import {FlagEmpasisCd, FlagEvProgDivi} from "@COMPONENTS/common/flag/Desktop";
import * as style from "@COMPONENTS/style/productlist/departurepopup";
import AirlineIcon from "@FRAMEWORK/ui/desktop/icon/AirlineIcon";
import {Flex} from "@FRAMEWORK/ui/desktop/layout";
import {format} from "@yb/utils";
import React, {useMemo} from "react";
import {EventExt, FilterType, SortType} from "./EventListPopup";

const EventList = (props: {
	data: Array<EventExt>;
	sort: SortType;
	filters: Array<FilterType>;
	setFilters: React.Dispatch<React.SetStateAction<Array<FilterType>>>;
	currentDate: string;
	onClose: () => void;
}) => {
	const {data, sort, filters, setFilters, currentDate} = props;

	const eventList = useMemo(() => {
		let filterList = [...data];
		const {prop, asc} = sort;
		if (currentDate) filterList = filterList.filter(v => v.outStartDt === currentDate);

		/** 정렬 */
		filterList = filterList.sort((a, b) => {
			if (asc) {
				// eslint-disable-next-line no-nested-ternary
				return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
			} else {
				// eslint-disable-next-line no-nested-ternary
				return Number(b[prop]) > Number(a[prop]) ? 1 : Number(b[prop]) < Number(a[prop]) ? -1 : 0;
			}
		});

		return filterList;
	}, [data, sort, currentDate]);

	// 예약 마감된 상품도 함께 보기
	const handleFilterReserve = () => {
		const copyArray = filters.filter(v => v.key !== "isEvReserve");
		setFilters(copyArray);
	};

	// 예약가능 여부
	const isReserve = filters.find(v => v.key === "isEvReserve")?.value === "true";

	return (
		<style.PromotionList>
			{eventList.length > 0 &&
				eventList.map((item, index) => {
					const {trTp, trCompanyNm, outDeprtTm, inArrvTm, evReserveStatus, goodsTp, seatClassCd, seatClassNm} = item;
					return (
						<li key={index}>
							<a href={item.weblinkurl || "#"} target="_blank" rel="noreferrer">
								<style.PromotionDate>
									<div>
										<span>{`${departureStart({evStartDt: item.outStartDt, outDeprtTm})} - ${returnArrival({
											evArriveDt: item.inArriveDt,
											inArrvTm,
										})}`}</span>
										<span>{item.dayStayInfo.replace(/^(\d)박(\d)일$/, "$1박 $2일")}</span>
									</div>
									<Flex gap="6">
										<FlagEmpasisCd emphasisCd={item.emphasisCd} />
										<FlagEvProgDivi evProgDivi={item.evProgDivi} evProgDiviNm={item.evProgDiviNm} />
									</Flex>
								</style.PromotionDate>
								<style.PromotionTitle>{item.evNm}</style.PromotionTitle>
								{item.accomNm && (
									<style.PromotionOption>
										<span>옵션</span>
										{item.accomNm}
									</style.PromotionOption>
								)}
								{item.couponYn === "Y" && (
									<style.CouponBox>
										<em>쿠폰</em>
										<style.CouponIcon>
											<i>
												{item.couponOptTy === "M"
													? format.koKRFormatNumber(item.couponDiscAmt)
													: `${item.couponDiscRate}%`}
											</i>
										</style.CouponIcon>
									</style.CouponBox>
								)}
								<style.PromotionPrice>
									<Flex grow={1}>
										<AirlineIcon
											img={getTrafficIconUrl(item)}
											title={
												trTp
													? `${trCompanyNm} ${seatClassCd && seatClassCd !== "EC" ? `(${seatClassNm})` : ""}`
													: "교통불포함"
											}
										/>
									</Flex>
									<div>
										{["F", "H"].indexOf(item.goodsTp) === -1 && item.evProgDivi !== "05" && (
											<style.SeatsAvailable>(잔여 {item.avlilBlockQty}석)</style.SeatsAvailable>
										)}
										{evReserveStatus === "end" && <style.Status state="deadline">예약마감</style.Status>}
										{evReserveStatus === "wait" && <style.Status state="waiting">예약대기</style.Status>}
										{evReserveStatus === "can" && (
											<style.Status state="possible">
												{["F", "H"].indexOf(goodsTp) > -1 ? "예약접수가능" : "예약가능"}
											</style.Status>
										)}
										<style.Price>
											<em>{format.koKRFormatNumber(item.sumPrice)}</em>원~
										</style.Price>
									</div>
								</style.PromotionPrice>
							</a>
						</li>
					);
				})}

			{!eventList ||
				(eventList.length === 0 && (
					<li>
						<style.EmptyBox>
							<p>{isReserve ? "해당 조건으로 예약가능한 상품이 없습니다." : "해당 조건의 상품이 없습니다."}</p>
							{isReserve && <a onClick={handleFilterReserve}>예약 마감된 상품도 함께 보기</a>}
						</style.EmptyBox>
					</li>
				))}
		</style.PromotionList>
	);
};

export default EventList;
